import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a8b2488c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-col" }
const _hoisted_2 = {
  key: 1,
  class: "text-primary mb-0"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "expander" }, "----", -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_Button = _resolveComponent("Button")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_ScrollPanel = _resolveComponent("ScrollPanel")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.$slots.card)
      ? _renderSlot(_ctx.$slots, "card", { key: 0 }, undefined, true)
      : _createCommentVNode("", true),
    (_ctx.isSmallScreen)
      ? (_openBlock(), _createBlock(_component_Panel, {
          key: 1,
          class: "col-lg-4 shadow-left sticky-bottom-panel",
          collapsed: _ctx.isMobilePriceSummaryCollapsed
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", {
                class: "d-flex justify-content-between align-items-center w-100 pt-2",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isMobilePriceSummaryCollapsed = !_ctx.isMobilePriceSummaryCollapsed))
              }, [
                (_ctx.isSpinnerVisible('priceSummary'))
                  ? (_openBlock(), _createBlock(_component_ProgressSpinner, {
                      key: 0,
                      "animation-duration": ".75s",
                      class: "m-0",
                      "stroke-width": "3",
                      style: {"width":"2.25rem","height":"2.25rem"}
                    }))
                  : (_openBlock(), _createElementBlock("h4", _hoisted_2, _toDisplayString(_ctx.formatCurrency(_ctx.totalPrice)), 1)),
                _hoisted_3,
                _createElementVNode("div", null, [
                  _createElementVNode("div", {
                    class: "d-flex align-items-center justify-content-end",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    _createVNode(_component_Button, {
                      class: "p-button-success p-button-raised p-button-sm p-button-arrow w-100 px-2 mb-1",
                      disabled: !_ctx.canSubmit,
                      label: _ctx.buttonText,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clickAction()))
                    }, null, 8, ["disabled", "label"])
                  ])
                ])
              ]),
              (_ctx.showTerms)
                ? (_openBlock(), _createElementBlock("small", _hoisted_4, [
                    _createVNode(_component_i18n_t, { keypath: "checkout.lblAgreeWithTerms" }, {
                      link: _withCtx(() => [
                        _createElementVNode("a", {
                          href: _ctx.checkoutStore.vm.termsAndConditionsLink,
                          target: "_blank"
                        }, _toDisplayString(_ctx.$t("common.termsAndConditions")), 9, _hoisted_5)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_ScrollPanel, { style: {"width":"100%","height":"clamp(200px, 30vh, 300px)"} }, {
              default: _withCtx(() => [
                (_ctx.isSpinnerVisible('priceSummary'))
                  ? (_openBlock(), _createBlock(_component_ProgressSpinner, {
                      key: 0,
                      "animation-duration": ".75s",
                      class: "d-block ml-auto mr-auto",
                      "stroke-width": "3"
                    }))
                  : (_ctx.$slots.priceSummary)
                    ? _renderSlot(_ctx.$slots, "priceSummary", { key: 1 }, undefined, true)
                    : _createCommentVNode("", true)
              ]),
              _: 3
            })
          ]),
          _: 3
        }, 8, ["collapsed"]))
      : _createCommentVNode("", true)
  ], 64))
}